import { render, staticRenderFns } from "./ComponentIndividualTimeLimits.vue?vue&type=template&id=aa79b2de&"
import script from "./ComponentIndividualTimeLimits.vue?vue&type=script&lang=ts&"
export * from "./ComponentIndividualTimeLimits.vue?vue&type=script&lang=ts&"
import style0 from "./ComponentIndividualTimeLimits.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDivider,VSpacer,VTextField})
